"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutationObserver = void 0;
/**
 * The Mutation Observer does not exist in Jest. This
 * function will return a Mock if it does not exist
 * on the window object.
 */
var mutationObserver = function (callback) {
    if (window.MutationObserver) {
        return new window.MutationObserver(callback);
    }
    else {
        // Mock for Jest
        var mockObserver = {
            disconnect: function () { },
            observe: function () { },
            takeRecords: function () { return []; },
        };
        return mockObserver;
    }
};
exports.mutationObserver = mutationObserver;
